import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ShieldCheck, Trash2, ArrowRight, Loader2 } from "lucide-react";
import api from "@/lib/api";

// صفحة عامة يطلبها Meta: تعليمات حذف بيانات إنستغرام + حالة طلب الحذف برمز التأكيد
export default function DataDeletion() {
  const [params] = useSearchParams();
  const code = params.get("code") || "";
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(!!code);

  useEffect(() => {
    if (!code) return;
    api.get(`/social/meta/deletion-status?code=${encodeURIComponent(code)}`).then((r) => setStatus(r.data)).catch(() => setStatus({ status: "not_found" })).finally(() => setLoading(false));
  }, [code]);

  return (
    <div className="min-h-screen bg-background text-foreground" dir="rtl" data-testid="data-deletion-page">
      <main className="max-w-2xl mx-auto px-6 py-14 space-y-8">
        <div className="flex items-center gap-3">
          <Trash2 className="w-7 h-7 text-primary" />
          <h1 className="text-3xl font-bold">حذف بيانات حسابات التواصل</h1>
        </div>
        {code && (
          <div className="rounded-2xl border border-border bg-card p-5" data-testid="deletion-status">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : status?.status === "completed" ? (
              <div className="flex items-start gap-3"><ShieldCheck className="w-6 h-6 text-emerald-400 shrink-0" />
                <div><div className="font-bold">تم حذف بياناتك بالكامل</div>
                  <div className="text-sm text-muted-foreground mt-1">رمز التأكيد: <b dir="ltr">{code}</b> · التاريخ: <span dir="ltr">{String(status.at).slice(0, 16).replace("T", " ")}</span> UTC</div>
                  <div className="text-xs text-muted-foreground mt-1">حُذفت توكنات الوصول وبيانات الحساب والمنشورات والإحصاءات المرتبطة به من خوادم رواج الذكية.</div></div>
              </div>
            ) : <div className="text-sm text-destructive">رمز التأكيد غير موجود. تواصل معنا على support@rawajsmart.com</div>}
          </div>
        )}
        <section className="space-y-3 text-sm leading-relaxed">
          <h2 className="text-lg font-bold">ما البيانات التي نخزّنها عند ربط إنستغرام؟</h2>
          <p>معرّف الحساب واسم المستخدم وعدد المتابعين، وتوكن وصول مشفّر، وإحصاءات المنشورات (إعجابات/تعليقات/مشاهدات) لعرض لوحة النمو ونشر محتوى حملاتك بموافقتك فقط.</p>
          <h2 className="text-lg font-bold">كيف تحذف بياناتك؟</h2>
          <p><b>١.</b> من داخل المنصة: <Link to="/app/social" className="text-primary underline">قنوات التواصل</Link> → «فصل» بجانب الحساب — يُحذف التوكن وكل البيانات المرتبطة فورًا.</p>
          <p><b>٢.</b> من إنستغرام: الإعدادات → Website permissions / Apps and websites → إزالة «Rawajsmart-IG» — تصلنا الإشارة ونحذف البيانات تلقائيًا ونعرض لك رمز تأكيد على هذه الصفحة.</p>
          <p><b>٣.</b> بالبريد: راسل <a href="mailto:support@rawajsmart.com" className="text-primary underline">support@rawajsmart.com</a> من بريد حسابك وسنحذف بياناتك خلال 48 ساعة.</p>
          <h2 className="text-lg font-bold">حذف حساب رواج بالكامل</h2>
          <p data-testid="account-deletion-note">يمكنك طلب حذف حسابك في رواج الذكية بالكامل عبر البريد أعلاه. الحذف <b>نهائي وغير قابل للتراجع</b>: يُحذف الحساب والمحفظة والرصيد والمشاريع والمحتوى وملفاته من قاعدة البيانات والتخزين فورًا ولا توجد نسخة قابلة للاستعادة؛ وتُحفظ الفواتير مجهّلة الهوية فقط للالتزام النظامي. راجع <Link to="/privacy" className="text-primary underline">سياسة الخصوصية</Link> (البند ٦).</p>
        </section>
        <Link to="/" className="inline-flex items-center gap-1 text-sm text-primary hover:underline"><ArrowRight className="w-4 h-4" /> العودة للرئيسية</Link>
      </main>
    </div>
  );
}
